import { useState } from 'react';
import './App.css';
import Navbar from './Navbar';
import Homepage from './Homepage';
import About from './About';
import Projects from './Projects';
import Certificates from './Certificates';
import Skills from './Skills';
import OtherProjects from './OtherProjects';
import Contact from './Contact';
import StarBackground from './StarBackground';

function App() {
  const [showOtherProjects, setShowOtherProjects] = useState(false);

  const handleToggleOtherProjects = () => {
    setShowOtherProjects(!showOtherProjects);
    if (!showOtherProjects) {
      setTimeout(() => {
        document.getElementById('otherprojects').scrollIntoView({ behavior: 'smooth' });
      }, 100);
    }
  };

  return (
    <div>
      <StarBackground />
      <Navbar onToggleOtherProjects={handleToggleOtherProjects} />
      <Homepage />
      <About />
      <Projects onShowOtherProjects={handleToggleOtherProjects} />
      {showOtherProjects && <OtherProjects />}
      <Skills />
      <Certificates />
      <Contact />
    </div>
  );
}

export default App;
